<template>
  <ECard
    as="section"
    class="instant-answer"
    :overflow-visible="overflowVisible"
    :elevation="0"
  >
    <div
      v-if="srTitle"
      class="sr-only"
      role="heading"
      aria-level="2"
      data-test-id="instant-answer-sr-title"
    >
      {{ srTitle }}
    </div>
    <div class="instant-answer__content">
      <slot />
    </div>
    <slot name="secondary-content" />
    <ERichContentFooter
      v-show="showFooter"
      as="footer"
      :sources="sources"
      :feedback-link="feedbackOptions"
      :powered-by-ecosia="poweredByEcosia"
      data-test-id="instant-answer-footer"
    >
      <template #left>
        <slot name="footer-left" />
      </template>
      <template #right>
        <slot name="footer-right" />
      </template>
    </ERichContentFooter>
  </ECard>
</template>

<script>
import ECard from '~~/common/vue/components/card';
import ERichContentFooter from '~~/common/vue/components/rich-content-footer';

export default {
  name: 'EInstantAnswer',
  components: {
    ECard,
    ERichContentFooter,
  },
  props: {
    ...ERichContentFooter.props,
    srTitle: {
      type: String,
      default: '',
    },
    showFooter: {
      type: Boolean,
      default: true,
    },
    overflowVisible: ECard.props.overflowVisible,
  },
  computed: {
    feedbackOptions() {
      return {
        errorMessage: this.$t('common.header.feedback.error'),
        options: [
          { label: this.$t('common.header.feedback.bullet1'), value: 'helpful' },
          { label: this.$t('common.header.feedback.bullet2'), value: 'missing' },
          { label: this.$t('common.header.feedback.bullet3'), value: 'wrong' },
          { label: this.$t('common.header.feedback.bullet4'), value: 'not_helpful' },
        ],
        query: this.$route ? this.$route.query?.q?.toString() : '',
        submitText: this.$t('common.header.feedback.send'),
        successMessage: this.$t('common.header.feedback.body2'),
        successTitle: this.$t('common.header.feedback.title2'),
        textareaPlaceholder: this.$t('common.header.feedback.tellmore'),
        title: this.$t('common.header.feedback.login'),
        ticketSubject: 'Search - Translation',
        url: process.env.feedbackUrl,
        ...this.feedbackLink,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.instant-answer {
  display: flex;
  flex-direction: column;

  @include desktop {
    border: solid $border-width var(--color-decorative-border-1);
  }
}

.instant-answer__content {
  flex-grow: 1;
  padding: $space-m;
}
</style>
